import React from "react";
import ListView from "../Common/Views/ListView";
import Chip from "@mui/material/Chip";

const WorkOrdersList = ({
    title = "Work Orders",
    filters = {},
    addButton = false, // Work orders are created via POS or Job Cards, not directly
    onSelect = null,
    columns = null,
}) => {

    const getStatusColor = (status) => {
        switch (status) {
            case 'DRAFT': return 'default';
            case 'IN_PROGRESS': return 'warning';
            case 'CLOSED': return 'info';
            case 'INVOICED': return 'success';
            case 'COMPLETED': return 'success'; // Legacy
            case 'CANCELED': return 'error';
            default: return 'default';
        }
    };

    const getStatusLabel = (status) => {
        const labels = {
            'DRAFT': 'Draft',
            'IN_PROGRESS': 'In Progress',
            'CLOSED': 'Closed',
            'INVOICED': 'Invoiced',
            'COMPLETED': 'Completed', // Legacy
            'CANCELED': 'Canceled'
        };
        return labels[status] || status;
    };

    const getOriginLabel = (originType) => {
        const labels = {
            'POS': 'Point of Sale',
            'JOB': 'Job Card'
        };
        return labels[originType] || originType;
    };

    // Columns configuration
    const columnsConfig = {
        workOrderNumber: {
            key: 'workOrderNumber',
            label: 'Order #',
            render: row => row.workOrderNumber
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => (
                <Chip 
                    label={getStatusLabel(row.status)} 
                    color={getStatusColor(row.status)}
                    size="small"
                />
            )
        },
        originType: {
            key: 'originType',
            label: 'Origin',
            render: row => (
                <Chip 
                    label={getOriginLabel(row.originType)} 
                    size="small"
                    variant="outlined"
                />
            )
        },
        location: {
            key: 'location',
            label: 'Location',
            render: row => row.location?.name || '-'
        },
        customer: {
            key: 'customer',
            label: 'Customer',
            render: row => row.customer?.name || '-'
        },
        vehicle: {
            key: 'vehicle',
            label: 'Vehicle',
            render: row => row.vehicle?.registrationNumber || '-'
        },
        createdAt: {
            key: 'createdAt',
            label: 'Created',
            render: row => row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '-'
        },
    };

    return (
        <ListView
            title={title}
            apiPath="/tenants/work-orders"
            filters={filters}
            addButton={addButton}
            rowClickPath={(workOrder) => `/sales/work-orders/${workOrder.id}`}
            onSelect={onSelect}
            columnsConfig={columnsConfig}
            columns={columns || ['workOrderNumber', 'status', 'originType', 'location', 'customer', 'createdAt']}
            searchBox={true}
            searchAttributes={[
                { name: 'workOrderNumber', label: 'Order Number', type: 'text' },
                { name: 'status', label: 'Status', type: 'select', options: [
                    { value: '', label: 'All' },
                    { value: 'DRAFT', label: 'Draft' },
                    { value: 'IN_PROGRESS', label: 'In Progress' },
                    { value: 'COMPLETED', label: 'Completed' },
                    { value: 'CANCELED', label: 'Canceled' },
                ]},
                { name: 'originType', label: 'Origin', type: 'select', options: [
                    { value: '', label: 'All' },
                    { value: 'POS', label: 'Point of Sale' },
                    { value: 'JOB', label: 'Job Card' },
                ]},
            ]}
            noResultsMessage="No work orders found"
        />
    );
};

export default WorkOrdersList;
